import FileUploadIcon from "@mui/icons-material/FileUpload";
import ImportThematicCatalogs from "./Create";

//params
export const THEMATIC_CATALOG_IMPORT = "thematic-catalogs/import";
//permissions

export const resources = {
  isMenu: true,
  icon: <FileUploadIcon />,
  name: THEMATIC_CATALOG_IMPORT,
  title: "Импорт на теми",
  list: <ImportThematicCatalogs />,
  permission: "editions",
};
